import { render, staticRenderFns } from "./PaymentAccommodationForm.vue?vue&type=template&id=35b9ce13"
import script from "./PaymentAccommodationForm.vue?vue&type=script&lang=js"
export * from "./PaymentAccommodationForm.vue?vue&type=script&lang=js"
import style0 from "./PaymentAccommodationForm.vue?vue&type=style&index=0&id=35b9ce13&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports